module.exports = __webpack_public_path__ + "static/rfyg-cf1ae53613fbb97ca88a209c4fe29495.png";